// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1vFY2","rootCenter":"LoadMoreObserver_rootCenter__3v0ZL","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__l7Zxi"};